import React from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import PCCAddendaPrintOut from '../PrintOut Tab/PccAddendaPrinoutsTOpdf/PCCAddendaPrinout'
import MarketingTemplates from './MarketingTemplates/MarketingTemplates'
import SalesTemplates from './Sales Templates/SalesTemplates'

const Templates = ({projectId,projectLookups}:any) => {
  return (
        <div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="pccTemplates">
                <Row className="m-0">
                    <div className='card card-css'>
                        <div className='card-body p-2'>
                            <Col sm={12} className='p-0'>
                                <Nav>
                                    <Nav.Item>
                                        <Nav.Link className='nav-tabs' eventKey="pccTemplates">PCC Templates</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link className='nav-tabs' eventKey="marketingTemplates">Marketing Templates</Nav.Link>
                                    </Nav.Item>
                                     <Nav.Item>
                                        <Nav.Link className='nav-tabs' eventKey="salesTemplates">Sales Templates</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                        </div>
                    </div>
                    <Col sm={12} className='p-0'>
                        <Tab.Content>
                            <Tab.Pane eventKey="pccTemplates"><PCCAddendaPrintOut projectId={projectId} projectLookups={projectLookups} /></Tab.Pane>
                            <Tab.Pane eventKey="marketingTemplates"><MarketingTemplates projectId={projectId} projectLookups={projectLookups}/></Tab.Pane>
                            <Tab.Pane eventKey="salesTemplates"><SalesTemplates projectId={projectId} projectLookups={projectLookups}/></Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>
    )
}

export default Templates
